import styled from "styled-components";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonContainer } from "../button.primary/button.primary.styled";
import {
  ButtonsContainer,
  InfoContainer,
  TabContainer,
} from "../move-inRegistrationTabs/move-inTabs.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";

import { ProfileUpdateData } from "../../stores/UserStore";
import {
  LegacyRef,
  MouseEventHandler,
  useEffect,
  useRef,
  useState,
} from "react";

import CONSTANTS from "../../utils/constants";
import { boolean } from "yup";
import { Modal, Typography } from "@mui/material";
import OtpInput from "react18-input-otp";
import generalStore from "../../stores/GeneralStore";
import ProfileOTP from "./ProfileOTP";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Edit from "../../assets/edit_icon.svg";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import DeleteModal from "./DeleteModal";
import DeleteAccount from "./DeleteAccount";
import DeleteOtp from "./DeleteOtp";

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  userProfile: any;
  // updateContactDetails: (data:{emailId:string, mobileNumber:string, oldMobileNumber:string})=>Promise<void>
  Submit: (data: ProfileUpdateData) => Promise<void>;
  setUpdate: any;
  updateLoader: Boolean;
}

const InputContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: #edimport { style } from '@mui/system';
f4f6;
    border: 1px solid #b6bfdc;
    margin: 0 0.5rem;
  }
`;

const validationSchema = Yup.object().shape({
  poBoxValue: Yup.string()
    .required(
      General?.codeLabels["cm_man_pobox"]?.label
        ? General?.codeLabels["cm_man_pobox"]?.label
        : "PO Box Number is required"
    )
    .matches(
      /^[0-9]+$/,
      General?.codeLabels["cm_numbererror"]?.label
        ? General?.codeLabels["cm_numbererror"]?.label
        : "PO Box Number must contain only digits"
    ),
  altEmail: Yup.string()
    .nullable()
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      General?.codeLabels["cm_emailerr"]?.label
    ),
  // Custom validation for at least one checkbox
  checkboxes: Yup.object()
    .shape({
      morningValue: Yup.bool(),
      afternoonValue: Yup.bool(),
      eveningValue: Yup.bool(),
    })
    .test(
      "Preferred time of communication is required",
      General?.codeLabels["cm_preffered_communication_req"]?.label ||
        "Preferred time of communication is required",
      (values) =>
        values.morningValue || values.afternoonValue || values.eveningValue
    ),
});

const Info = ({ Submit, setUpdate, updateLoader }: Props) => {
  const [numbers, setNumbers] = useState("");
  const [showError, setShowError] = useState(false);
  const [poBoxEr, setPoBoxEr] = useState(false);
  const [otpModalOpen, setOTPModalOpen] = useState<boolean>(false);
  const alternateEmailValue = useRef<HTMLInputElement | null>(null);

  //   const vatValue = useRef<HTMLInputElement | null>(null)
  const emailValue = useRef<HTMLInputElement | null>(null);
  const genderValue = useRef<HTMLSelectElement | null>(null);
  const nationalityValue = useRef<HTMLSelectElement | null>(null);
  const languageValue = useRef<HTMLSelectElement | null>(null);
  const favouriteServiceDeliveryChannelValue = useRef<HTMLSelectElement | null>(
    null
  );
  const favouritePaymentChannelValue = useRef<HTMLSelectElement | null>(null);
  const morningValue = useRef<HTMLInputElement | null>(null);
  const afternoonValue = useRef<HTMLInputElement | null>(null);
  const eveningValue = useRef<HTMLInputElement | null>(null);
  const emirateValue = useRef<HTMLSelectElement | null>(null);
  const poBoxValue = useRef<HTMLInputElement | null>(null);
  const dateOfBirthValue = useRef<HTMLInputElement | null>(null);
  const mobileNumberValue = useRef<HTMLInputElement | null>(null);
  const poBoxRegex: any = /^[0-9]+$/;
  const [delModalOpen, setDELModalOpen] = useState(false);
  const [delotp, setDeletOtp] = useState(false);

  const [enableMobilebleField, setEnableMobilebleField] = useState();

  const handleSubmit = (values: any) => {
    // Rest of your code remains the same

    const poBox = values.poBoxValue; // Access the poBoxValue from the values object
    const alternateEmail = alternateEmailValue.current?.value;
    const email = emailValue.current?.value;
    const gender = genderValue.current?.value;
    const nationality = nationalityValue.current?.value;
    const language = languageValue.current?.value;
    const favouriteServiceDeliveryChannel =
      favouriteServiceDeliveryChannelValue.current?.value;
    const favouritePaymentChannel = favouritePaymentChannelValue.current?.value;

    const morning = values.checkboxes?.morningValue;
    const afternoon = values.checkboxes?.afternoonValue;
    const evening = values.checkboxes?.eveningValue;

    const emirate = emirateValue.current?.value;
    const dateOfBirth = dateOfBirthValue.current?.value;
    const mobileNumber = mobileNumberValue.current?.value;
    var filterNationality: any =
      General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
        ? CONSTANTS.countriesAr?.filter(
            (nationalityConst) => nationalityConst?.key == nationality
          )
        : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "HIN"
        ? CONSTANTS.countriesHi?.filter(
            (nationalityConst) => nationalityConst?.key == nationality
          )
        : CONSTANTS.countriesEn?.filter(
            (nationalityConst) => nationalityConst?.key == nationality
          );

    setPoBoxEr(false);
    setShowError(false);
    if (!poBoxRegex.test(poBox)) {
      setPoBoxEr(true);
    }
    if (
      email &&
      gender &&
      nationality &&
      language &&
      favouriteServiceDeliveryChannel &&
      favouritePaymentChannel &&
      emirate &&
      poBox &&
      dateOfBirth &&
      mobileNumber
    ) {
      const dataa = {
        poBox,
        email,
        mobileNumber,
        dob: dateOfBirth,
        emirate,
        gender: {
          key: gender,
          value: gender == "M" ? "Male" : "Female",
        },
        nationality: {
          key: nationality.split("-")[0],
          value: filterNationality[0]?.value,
        },
        language: {
          key: language.split("-")[0],
          value: language.split("-")[1],
        },
        alternateEmail,
        favouriteServiceDeliveryChannel: {
          key: favouriteServiceDeliveryChannel.split("-")[0],
          value: favouriteServiceDeliveryChannel.split("-")[1],
        },
        favouritePaymentChannel: {
          key: favouritePaymentChannel.split("-")[0],
          value: favouritePaymentChannel.split("-")[1],
        },
        morning: morning as boolean,
        afternoon: afternoon as boolean,
        evening: evening as boolean,

        //mafroud y koun fi account number (min userValidatedDetails)
      };
      setShowError(false);
      Submit(dataa);
      // const data = {
      //   emirate,
      //   pobox: poBox,
      // };
      // User?.updatePobox({ errorId: "updatePobox", data });
    } else {
      setShowError(true);
    }
  };

  const handleChange = (otpConfirm: string) => {
    setNumbers(otpConfirm);
  };
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const handleChangeMobileNumber = () => {
    setOTPModalOpen(true);
    setIsMobileEdit(true);
  };

  const handleChangeEmailNumber = () => {
    setOTPModalOpen(true);
    setIsMobileEdit(false);
  };

  const contrast = General?.contrast;
  const [userProfile, setUserProfile] = useState<any>({});
  const [email, setEmail] = useState<any>();
  const [mobile, setMobile] = useState<any>();
  const getUser = async () => {
    const res: any =  await User.getProfile(User.info.personId as string);;
    if (res) {
      setUserProfile(res?.result);
    }
  };
  useEffect(() => {
    getUser();
  }, [email, mobile]);

  const handleDownload = async () => {
    const fileUrl = 'http://213.42.234.23:8901/SecurityUpdates/api/users/0082202410/profile/download';

    try {
      // const response = await fetch(fileUrl, {
      //   method: 'GET',
      //   headers: {
      //     authorization : "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IkNoYW1hcmEiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDgyMjAyNDEwIiwiZW1haWwiOiJ0ZXN0aW5nLm1vYWxhamFoQGdtYWlsLmNvbSIsIm5iZiI6MTc0NzQxNTA5OSwiZXhwIjoxNzU1MTkxMDk5LCJpYXQiOjE3NDc0MTUwOTl9.tuSeq01t-GydvNPZk0UAV_0yy2oYlUmapilUOoOLn3U"
      //   },
      // });

      // if (!response.ok) {
      //   throw new Error('Network response was not ok');
      // }

      // const blob = await response.blob();

      const blob = await User.downloadProfile(User.info.personId as string);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;


       const  fileName = "Profile-" + User.info.userName + ".csv";
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <div
      style={{
        backgroundColor: contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "#fff",
        width: General?.isLargeScreen ? "93%" : "100%",
        padding: General?.isLargeScreen ? "3.125rem 9rem" : "0rem 1rem",
        marginLeft: General?.isLargeScreen ? "50px" : "",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: General?.isLargeScreen ? "row" : "column",
          alignItems: General?.isLargeScreen ? "center" : "",
          justifyContent: "space-between",
        }}
      >
        <h3
          style={{
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            lineHeight: "32px",
            color: contrast?.contrastColor
              ? contrast?.contrastColor
              : General?.ColorAss,
          }}
        >
          {General?.codeLabels["cm_account_information"]?.label !== undefined
            ? General?.codeLabels["cm_account_information"]?.label
            : "Account Information"}
        </h3>
        <ButtonSecondary
          style={{
            width: General?.isLargeScreen ? "10%" : "100%",
            padding: "5px 80px",
            whiteSpace: "nowrap",
            fontWeight: "bold",
            fontSize: `${General.accessibility.fontSize}rem`,
            zIndex: 0,
            color: contrast?.contrastColor
              ? contrast?.contrastColor
              : General?.ColorAss,
            borderColor: contrast?.contrastColor
              ? contrast?.contrastColor
              : General?.ColorAss,
            background: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
          }}
          onClick={() => setDELModalOpen(true)}
        >
          {General?.codeLabels["cm_delete_account"]?.label
            ? General?.codeLabels["cm_delete_account"]?.label
            : "DELETE ACCOUNT"}
        </ButtonSecondary>
      </div>
      <Formik
        initialValues={{
          poBoxValue: User?.poBoxData?.city,
          altEmail: User?.profile?.alternateEmail,
          checkboxes: {
            morningValue: User?.profile?.morning || false,
            afternoonValue: User?.profile?.afternoon || false,
            eveningValue: User?.profile?.evening || false,
          },
          // Initialize other fields
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleBlur }) => (
          <Form>
            <TabContainer>
              <InfoContainer
                style={{
                  display: "flex",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  width: General?.isLargeScreen ? "" : "100%",
                }}
              >
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    position: "relative",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_mobilenumber"]?.label !== undefined
                    ? General?.codeLabels["cm_mobilenumber"]?.label
                    : "Mobile Number*(05X-Xxx-Xxxx)"}
                  <input
                    style={{
                      backgroundColor: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "lightgray",
                      direction:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode === "ARA"
                          ? "rtl"
                          : "ltr",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                    }}
                    type="tel"
                    defaultValue={mobile ? mobile : userProfile?.mobileNumber}
                    ref={mobileNumberValue}
                    readOnly={true}
                  />
                  <span
                    onClick={handleChangeMobileNumber}
                    style={{
                      position: "absolute",
                      right:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode !== "ARA"
                          ? "1rem"
                          : "",
                      left:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode === "ARA"
                          ? "1rem"
                          : "",
                      bottom: "1.3rem",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2185_37883)">
                        <path
                          d="M18.2189 0.125L17.5314 0.78125L4.03136 13.2812H4.00011C3.65245 13.6289 3.40636 14.1367 3.40636 14.6562C3.40636 14.918 3.45714 15.1797 3.56261 15.4062L1.00011 21.9062C0.898543 22.207 0.988386 22.4883 1.18761 22.6875C1.38682 22.8867 1.79307 23 2.09386 23L8.5626 20.4688C8.82432 20.6133 9.12901 20.6875 9.4376 20.6875C9.95714 20.6875 10.4649 20.4414 10.8126 20.0938L10.8439 20.0625L23.2501 6.46875L23.8751 5.78125L23.2189 5.09375L18.9064 0.78125L18.2189 0.125ZM18.1564 2.875L21.1251 5.84375L13.3751 14.3125L9.7501 10.6875L18.1564 2.875ZM8.6251 11.6875L12.3439 15.4062L10.4689 17.4688L6.59385 13.5938L8.6251 11.6875ZM8.3126 22L3.09386 24H24.0001V22H8.3126Z"
                          fill={
                            contrast?.contrastBackground
                              ? contrast?.contrastBackground
                              : "#62AA51"
                          }
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2185_37883">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    position: "relative",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_primaryemail"]?.label !== undefined
                    ? General?.codeLabels["cm_primaryemail"]?.label
                    : "Primary Email Address"}

                  <input
                    style={{
                      backgroundColor: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "lightgray",
                      direction:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode === "ARA"
                          ? "rtl"
                          : "ltr",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                    }}
                    type="text"
                    placeholder={
                      General?.codeLabels["cm_type_here"]?.label
                        ? General?.codeLabels["cm_type_here"]?.label
                        : "Type Here"
                    }
                    // defaultValue={userProfile?.email?userProfile?.email: User?.profile?.email}
                    defaultValue={email ? email : userProfile?.email}
                    ref={emailValue}
                    readOnly={true}
                  />
                  <span
                    onClick={handleChangeEmailNumber}
                    style={{
                      bottom: "1.3rem",
                      position: "absolute",
                      right:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode === "ARA"
                          ? ""
                          : "1.3rem",
                      left:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode === "ARA"
                          ? "1rem"
                          : "",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_2185_37883)">
                        <path
                          d="M18.2189 0.125L17.5314 0.78125L4.03136 13.2812H4.00011C3.65245 13.6289 3.40636 14.1367 3.40636 14.6562C3.40636 14.918 3.45714 15.1797 3.56261 15.4062L1.00011 21.9062C0.898543 22.207 0.988386 22.4883 1.18761 22.6875C1.38682 22.8867 1.79307 23 2.09386 23L8.5626 20.4688C8.82432 20.6133 9.12901 20.6875 9.4376 20.6875C9.95714 20.6875 10.4649 20.4414 10.8126 20.0938L10.8439 20.0625L23.2501 6.46875L23.8751 5.78125L23.2189 5.09375L18.9064 0.78125L18.2189 0.125ZM18.1564 2.875L21.1251 5.84375L13.3751 14.3125L9.7501 10.6875L18.1564 2.875ZM8.6251 11.6875L12.3439 15.4062L10.4689 17.4688L6.59385 13.5938L8.6251 11.6875ZM8.3126 22L3.09386 24H24.0001V22H8.3126Z"
                          fill={
                            contrast?.contrastBackground
                              ? contrast?.contrastBackground
                              : "#62AA51"
                          }
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2185_37883">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </Label>
              </InfoContainer>
              <h3
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                  lineHeight: "32px",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  marginTop: "2rem",
                }}
              >
                {General?.codeLabels["cm_personal_information"]?.label
                  ? General?.codeLabels["cm_personal_information"]?.label
                  : "Personal Information"}
              </h3>

              <InfoContainer
                style={{
                  display: General?.isLargeScreen ? "grid" : "flex",
                  flexDirection: General?.isLargeScreen ? "row" : "column",
                  width: General?.isLargeScreen ? "" : "100%",
                }}
              >
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_dob"]?.label !== undefined
                    ? General?.codeLabels["cm_dob"]?.label
                    : "Date Of Birth"}
                  <input
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    type="date"
                    max={new Date().toISOString().split("T")[0]}
                    ref={dateOfBirthValue}
                    defaultValue={User?.profile?.dob?.split("T")[0]}
                  />
                  <div style={{ height: "0.5rem" }}></div>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_gender"]?.label !== undefined
                    ? General?.codeLabels["cm_gender"]?.label
                    : "Gender"}
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={genderValue}
                  >
                    <option
                      selected={
                        User?.profile?.gender?.key == "M" ? true : false
                      }
                      value="M"
                    >
                      {General?.codeLabels["cm_male"]?.label !== undefined
                        ? General?.codeLabels["cm_male"]?.label
                        : "Male"}
                    </option>
                    <option
                      selected={
                        User?.profile?.gender?.key == "F" ? true : false
                      }
                      value="F"
                    >
                      {General?.codeLabels["cm_female"]?.label !== undefined
                        ? General?.codeLabels["cm_female"]?.label
                        : "Female"}
                    </option>
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_nationality"]?.label !== undefined
                    ? General?.codeLabels["cm_nationality"]?.label
                    : "Nationality"}
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={nationalityValue}
                  >
                    <option selected disabled>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    {General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? CONSTANTS.countriesAr.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                User?.profile?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "HIN"
                      ? CONSTANTS.countriesHi.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                User?.profile?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : CONSTANTS.countriesEn.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                User?.profile?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })}
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_preffered_language"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_language"]?.label
                    : "Preferred Language"}
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={languageValue}
                  >
                    <option
                      selected={
                        User?.profile?.language?.key == "ENG" ? true : false
                      }
                      value="ENG-English"
                    >
                      {" "}
                      {General?.codeLabels["cm_eng"]?.label !== undefined
                        ? General?.codeLabels["cm_eng"]?.label
                        : "English"}
                    </option>
                    <option
                      selected={
                        User?.profile?.language?.key == "HIN" ? true : false
                      }
                      value="HIN-Hindi"
                    >
                      {" "}
                      {General?.codeLabels["cm_hin"]?.label !== undefined
                        ? General?.codeLabels["cm_hin"]?.label
                        : "Hindi"}
                    </option>
                    <option
                      selected={
                        User?.profile?.language?.key == "ARA" ? true : false
                      }
                      value="ARA-Arabic"
                    >
                      {" "}
                      {General?.codeLabels["cm_ara"]?.label !== undefined
                        ? General?.codeLabels["cm_ara"]?.label
                        : "Arabic"}
                    </option>
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>{" "}
                {/* To Select */}
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_pobox"]?.label !== undefined
                    ? General?.codeLabels["cm_pobox"]?.label
                    : "PO Box Number"}
                  *
                  <Field
                    type="number"
                    // defaultValue={User?.poBoxData?.city}
                    // value={User?.poBoxData?.city}
                    // innerRef={}
                    style={{
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e5eff2",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                    name="poBoxValue"
                  />
                  <div style={{ height: "0.5rem" }}>
                    {" "}
                    <ErrorMessage
                      name="poBoxValue"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_emirate"]?.label !== undefined
                    ? General?.codeLabels["cm_emirate"]?.label
                    : "Emirate"}
                  *
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={emirateValue}
                  >
                    <option
                      selected={
                        User?.poBoxData?.state == "ABU DH" ? true : false
                      }
                      key={"ABU DH"}
                      value="ABU DH"
                    >
                      {General?.codeLabels["cm_abudhabi"]?.label !== undefined
                        ? General?.codeLabels["cm_abudhabi"]?.label
                        : "Abu Dhabi"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "AJMAN" ? true : false
                      }
                      key={"AJMAN"}
                      value="AJMAN"
                    >
                      {" "}
                      {General?.codeLabels["cm_ajman"]?.label !== undefined
                        ? General?.codeLabels["cm_ajman"]?.label
                        : "Ajman"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "DUBAI" ? true : false
                      }
                      key={"DUBAI"}
                      value="DUBAI"
                    >
                      {General?.codeLabels["cm_dubai"]?.label !== undefined
                        ? General?.codeLabels["cm_dubai"]?.label
                        : "Dubai"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "FUJAIR" ? true : false
                      }
                      key={"FUJAIR"}
                      value="FUJAIR"
                    >
                      {" "}
                      {General?.codeLabels["cm_fujairah"]?.label !== undefined
                        ? General?.codeLabels["cm_fujairah"]?.label
                        : "Fujairah"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "RAS AL" ? true : false
                      }
                      key={"RAS AL"}
                      value="RAS AL"
                    >
                      {" "}
                      {General?.codeLabels["cm_rasalkhaimah"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_rasalkhaimah"]?.label
                        : "Ras Al Khaimah"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "SHARJA" ? true : false
                      }
                      key={"SHARJA"}
                      value="SHARJA"
                    >
                      {General?.codeLabels["cm_sharjah"]?.label !== undefined
                        ? General?.codeLabels["cm_sharjah"]?.label
                        : "Sharjah"}
                    </option>
                    <option
                      selected={
                        User?.poBoxData?.state == "UMM AL" ? true : false
                      }
                      key={"UMM AL"}
                      value="UMM AL"
                    >
                      {" "}
                      {General?.codeLabels["cm_ummalquwain"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_ummalquwain"]?.label
                        : "Umm Al Quwain"}
                    </option>
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>{" "}
                {/* To Select */}
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_altemail"]?.label !== undefined
                    ? General?.codeLabels["cm_altemail"]?.label
                    : "Alternate Email"}
                  <Field
                    type="email"
                    style={{
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e5eff2",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                    name="altEmail"
                    innerRef={alternateEmailValue}
                    // defaultValue={User?.profile?.alternateEmail}
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="altEmail"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_fsd"]?.label !== undefined
                    ? General?.codeLabels["cm_fsd"]?.label
                    : "Favorite Service Delivery Channel"}
                  *
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={favouriteServiceDeliveryChannelValue}
                  >
                    {/* TODO: check reponse values and insert into options */}
                    <option
                    selected={
                      User?.profile?.favouriteServiceDeliveryChannel?.key ==
                      "CHSC"
                        ? true
                        : false
                    }
                    value="CHSC-Customer Happiness Service Center"
                  >
                    {" "}
                    {General?.codeLabels["cm_happser"]?.label !== undefined
                      ? General?.codeLabels["cm_happser"]?.label
                      : "Customer Happiness Service Center"}
                  </option>
                    <option
                      selected={
                        User?.profile?.favouriteServiceDeliveryChannel?.key ==
                        "ASW"
                          ? true
                          : false
                      }
                      value="ASW-Ajman Sewerage website"
                    >
                      {" "}
                      {General?.codeLabels["cm_website"]?.label !== undefined
                        ? General?.codeLabels["cm_website"]?.label
                        : "Ajman Sewerage website"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouriteServiceDeliveryChannel?.key ==
                        "ASMA"
                          ? true
                          : false
                      }
                      value="ASMA-Ajman Sewerage mobile App"
                    >
                      {General?.codeLabels["cm_mobileapp"]?.label !== undefined
                        ? General?.codeLabels["cm_mobileapp"]?.label
                        : "Ajman Sewerage mobile App"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouriteServiceDeliveryChannel?.key ==
                        "ASCC"
                          ? true
                          : false
                      }
                      value="ASCC-Ajman Sewerage Contact Center"
                    >
                      {General?.codeLabels["cm_contactcen"]?.label !== undefined
                        ? General?.codeLabels["cm_contactcen"]?.label
                        : "Ajman Sewerage Contact Center"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouriteServiceDeliveryChannel?.key ==
                        "E"
                          ? true
                          : false
                      }
                      value="E-Email"
                    >
                      {" "}
                      <option value="E-Email">
                        {General?.codeLabels["cm_mob_email"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mob_email"]?.label
                          : "Email "}
                      </option>
                    </option>
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>{" "}
                {/* To Select */}
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_preffered_payment_chanel"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_payment_chanel"]?.label
                    : "Preferred Payment Channel"}
                  *
                  <select
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      fontSize: `${General.accessibility.fontSize}rem`,
                      background: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                    ref={favouritePaymentChannelValue}
                  >
                    {/* TODO: same as above*/}
                    <option
                    selected={
                      User?.profile?.favouritePaymentChannel?.key == "CHSC"
                        ? true
                        : false
                    }
                    value="CHSC-Customer Happiness Service Center"
                  >
                    {General?.codeLabels["cm_payhsc"]?.label !== undefined
                      ? General?.codeLabels["cm_payhsc"]?.label
                      : "Customer Happiness Service Center"}
                  </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "PYK"
                          ? true
                          : false
                      }
                      value="PYK-Payment Kiosks"
                    >
                      {" "}
                      {General?.codeLabels["cm_paykio"]?.label !== undefined
                        ? General?.codeLabels["cm_paykio"]?.label
                        : "Payment Kiosks"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "AAE"
                          ? true
                          : false
                      }
                      value="AAE-Al Ansari Exchange"
                    >
                      {General?.codeLabels["cm_payansari"]?.label !== undefined
                        ? General?.codeLabels["cm_payansari"]?.label
                        : "Al Ansari Exchange"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "UAEEX"
                          ? true
                          : false
                      }
                      value="UAEEX-UAE Exchange"
                    >
                      {" "}
                      {General?.codeLabels["cm_payuae"]?.label !== undefined
                        ? General?.codeLabels["cm_payuae"]?.label
                        : "UAE Exchange"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "AJBNK"
                          ? true
                          : false
                      }
                      value="AJBNK-Ajman Bank"
                    >
                      {" "}
                      {General?.codeLabels["cm_payajmanbank"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_payajmanbank"]?.label
                        : "Ajman Bank"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "DXBIB"
                          ? true
                          : false
                      }
                      value="DXBIB-Dubai Islamic Bank"
                    >
                      {" "}
                      {General?.codeLabels["cm_paydib"]?.label !== undefined
                        ? General?.codeLabels["cm_paydib"]?.label
                        : "Dubai Islamic Bank"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "ENBD"
                          ? true
                          : false
                      }
                      value="ENBD-Emirates NBD"
                    >
                      {General?.codeLabels["cm_payendb"]?.label !== undefined
                        ? General?.codeLabels["cm_payendb"]?.label
                        : "Emirates NBD"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "CASH"
                          ? true
                          : false
                      }
                      value="CASH-Cash Deposit"
                    >
                      {" "}
                      {General?.codeLabels["cm_paycash"]?.label !== undefined
                        ? General?.codeLabels["cm_paycash"]?.label
                        : "Cash Deposit"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "CHQ"
                          ? true
                          : false
                      }
                      value="CHQ-Cheque Deposit"
                    >
                      {" "}
                      {General?.codeLabels["cm_paycheque"]?.label !== undefined
                        ? General?.codeLabels["cm_paycheque"]?.label
                        : "Cheque Deposit"}
                    </option>
                    <option
                      selected={
                        User?.profile?.favouritePaymentChannel?.key == "ONLN"
                          ? true
                          : false
                      }
                      value="ONLN-Online"
                    >
                      {" "}
                      {General?.codeLabels["cm_payonline"]?.label !== undefined
                        ? General?.codeLabels["cm_payonline"]?.label
                        : "Online"}
                    </option>
                  </select>
                  <div style={{ height: "0.5rem" }}></div>
                </Label>{" "}
                {/* To Date Picker */}
                <Label
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    fontFamily: "Segoe UI",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                    height: "100px",
                    width: General?.isLargeScreen ? "" : "100%",
                  }}
                >
                  {General?.codeLabels["cm_preffered_com_chanel"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_com_chanel"]?.label
                    : "Preferred Time of Communicationl"}
                  *
                  <div
                    style={{
                      display: "flex",
                      width: "75%",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Field
                        className="inputRadio1"
                        type="checkbox"
                        name="checkboxes.morningValue"
                        checked={values.checkboxes.morningValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          accentColor: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "",
                          width: "15px",
                        }}
                      />
                      <p      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        marginTop: "1rem",
                        marginLeft: "0.5rem",
                        marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "0.5rem" : "",
                      }}>
                        {General?.codeLabels["cm_morning"]?.label || "Morning"}
                      </p>
                    </div>

                    <div style={{ display: "flex" }}>
                      <Field
                        className="inputRadio1"
                        type="checkbox"
                        name="checkboxes.afternoonValue"
                        checked={values.checkboxes.afternoonValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          accentColor: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "",
                          width: "15px",
                        }}
                      />
                      <p      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        marginTop: "1rem",
                        marginLeft: "0.5rem",
                        marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "0.5rem" : "",
                      }}>
                        {General?.codeLabels["cm_afternoon"]?.label ||
                          "Afternoon"}
                      </p>
                    </div>

                    <div style={{ display: "flex" }}>
                      <Field
                        className="inputRadio1"
                        type="checkbox"
                        name="checkboxes.eveningValue"
                        checked={values.checkboxes.eveningValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{
                          accentColor: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "#62AA51",
                          background: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : "",
                          width: "15px",
                        }}
                      />
                      <p      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : General?.ColorAss,
                        marginTop: "1rem",
                        marginLeft: "0.5rem",
                        marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "0.5rem" : "",
                      }}>
                        {General?.codeLabels["cm_evening"]?.label || "Evening"}
                      </p>
                    </div>
                   
                  </div>
                  <Label>
                      {" "}
                      <div style={{ height: "0.5rem" }}>
                        {" "}
                        <ErrorMessage
                          name="checkboxes"
                          component="div"
                          className="error-message"
                        />
                      </div>
                    </Label>
                </Label>{" "}
                {/* To Select */}
              </InfoContainer>

              <ButtonsContainer
                style={{
                  width: General?.isLargeScreen ? "25%" : "100%",
                  gap: "1rem",
                  marginTop: "3.75rem",
                }}
              >
                <ButtonSecondary
                  onClick={handleSubmit}
                  type="submit"
                  style={{
                    width: General?.isLargeScreen ? "228px" : "100%",
                    height: "50px",
                    fontWeight: "bold",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    border: "none",
                  }}
                >
                  {updateLoader ? (
                    <Spinner width="30px" height="30px" />
                  ) : General?.codeLabels["cm_update"]?.label !== undefined ? (
                    General?.codeLabels["cm_update"]?.label
                  ) : (
                    "UPDATE"
                  )}
                </ButtonSecondary>
                <ButtonSecondary
                  onClick={handleDownload}
                  type="button"
                  style={{
                    width: General?.isLargeScreen ? "228px" : "55%",
                    height: "50px",
                    fontWeight: "bold",
                    fontSize:General?.isLargeScreen? `${General.accessibility.fontSize}rem`:"0.8rem",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#fff",
                    background: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : General?.ColorAss,
                    border: "none",
                  }}
                >
                  <span style={{width: "30rem"}}>{ General?.codeLabels["cm_downloaddetails"]?.label !== undefined ? 
                    General?.codeLabels["cm_downloaddetails"]?.label
                  : 
                    "Download your details"
                  }</span>
                  
                </ButtonSecondary>
              </ButtonsContainer>
            </TabContainer>
          </Form>
        )}
      </Formik>
      <Modal
        open={otpModalOpen}
        onClose={() => {
          setOTPModalOpen(false);
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ProfileOTP
          mobile={User?.profile?.mobileNumber}
          personID={User.info.personId}
          email={User?.profile?.email}
          onClose={() => {
            setOTPModalOpen(false);
          }}
          setEnableMobilebleField={setEnableMobilebleField}
          setEmail={setEmail}
          setMobile={setMobile}
          isMobileEdit={isMobileEdit}
        />
        {/*onVerify={updateContactDetails}*/}
      </Modal>
      <Modal
        open={delModalOpen}
        onClose={() => setDELModalOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DeleteAccount
          onClose={() => setDELModalOpen(false)}
          delData={() => {
            setDeletOtp(true);
            setDELModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        open={delotp}
        onClose={() => {
          setDeletOtp(false);
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DeleteOtp
          mobile={User?.profile?.mobileNumber}
          personID={User.info.personId}
          email={User?.profile?.email}
          onClose={() => {
            setDeletOtp(false);
          }}
          setEnableMobilebleField={setEnableMobilebleField}
          setEmail={setEmail}
          setMobile={setMobile}
        />
        {/*onVerify={updateContactDetails}*/}
      </Modal>
    </div>
  );
};
export default observer(Info);
